import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/nextjs';
import env from 'app/env';

// Exported for test
export const UPDATE_INTERVAL = 1000 * 60 * 15; // 15 min

const useReloadManager = (): boolean => {
    const [updatedVersion, setUpdatedVersion] = useState(false);
    const [reloadPath, setReloadPath] = useState(null);

    const router = useRouter();

    useEffect(() => {
        const interval = setInterval(async () => {
            try {
                const response = await fetch('/build.json');
                const buildData = await response.json();

                // Compare local app version with distributed app version
                if (env.APP_VERSION !== buildData.APP_VERSION) {
                    setUpdatedVersion(true);
                }
            } catch (error) {
                Sentry.setExtra('error', error);
                Sentry.captureException(error);
            }
        }, UPDATE_INTERVAL);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const reloadManager = (pathname, args) => {
            if (args?.shallow !== true) {
                setReloadPath(pathname);
            }
        };

        router.events.on('beforeHistoryChange', reloadManager);

        return () => {
            router.events.off('beforeHistoryChange', reloadManager);
        };
    }, []);

    useEffect(() => {
        if (reloadPath && updatedVersion) {
            window.location.pathname = reloadPath;
        }
    }, [reloadPath, updatedVersion]);

    return updatedVersion;
};

export default useReloadManager;
